<template>
  <v-app id="daisukeApp">
    <v-app-bar clipped-left app class="daisuke-main-bar">
      <nuxt-link to="/" class="home-link">
        <svg viewBox="208.437 144.938 64 64" width="64" height="64">
          <defs>
            <linearGradient
              id="paint0_linear_0_1"
              x1="100"
              y1="-1.8692e-06"
              x2="62.494"
              y2="119.598"
              gradientUnits="userSpaceOnUse"
              gradientTransform="matrix(0.640319, 0, 0, 0.640319, 208.436988, 144.9379)"
            >
              <stop stop-color="#CC2124" />
              <stop offset="1" stop-color="#E2B528" />
            </linearGradient>
          </defs>
          <rect
            width="64"
            height="64"
            fill="url(#paint0_linear_0_1)"
            x="208.437"
            y="144.938"
            style=""
          />
          <path
            d="M 240.418 181.548 C 240.895 180.246 241.682 179.055 242.299 177.836 C 244.544 179.553 245.105 186.589 245.835 189.303 C 246.566 191.629 248.361 194.538 251.112 194.76 C 250.242 194.649 250.045 193.789 249.877 193.07 C 249.737 192.544 249.625 191.989 249.512 191.464 C 248.81 186.533 249.036 181.464 247.576 176.645 C 247.154 175.454 246.285 173.404 244.656 173.958 C 243.506 172.823 242.523 171.492 241.793 170.053 C 240.952 168.197 240.081 166.147 239.773 164.126 C 238.79 166.48 239.605 169.305 240.755 171.465 C 241.485 172.712 242.242 173.958 242.916 175.205 C 242.832 175.315 242.748 175.426 242.692 175.536 C 241.625 177.393 240.952 179.47 240.418 181.548 Z M 239.324 182.988 C 239.633 180.689 240.446 178.279 241.821 176.368 L 241.934 176.202 C 241.456 174.651 240.783 173.183 239.941 171.826 C 240.559 173.848 240.783 175.953 240.615 178.058 C 240.081 179.055 239.689 180.135 239.435 181.243 C 239.267 182.074 239.155 182.905 239.155 183.736 C 238.733 185.675 238.173 187.918 238.397 189.912 C 238.594 188.555 238.931 187.226 239.408 185.952 C 239.24 184.955 239.212 183.958 239.324 182.988 Z M 234.413 176.036 C 234.524 173.709 233.514 171.327 231.998 169.582 C 230.258 167.727 227.62 166.675 226.778 164.127 L 226.805 164.431 C 226.833 164.957 226.89 165.455 226.974 165.955 C 227.311 168.669 228.63 170.94 230.96 172.435 C 232.363 173.377 233.542 174.624 234.413 176.036 Z M 253.638 172.796 C 254.508 173.238 254.088 174.43 254.424 175.15 C 255.21 176.618 256.473 177.725 256.894 179.387 C 257.118 180.468 257.175 181.548 257.063 182.657 C 256.389 179.166 253.499 177.199 252.319 174.126 C 252.011 173.294 252.291 172.63 253.162 172.658 C 253.33 172.657 253.499 172.712 253.638 172.796 Z M 251.87 193.984 C 252.572 192.322 252.881 190.55 252.769 188.749 C 252.544 185.342 250.608 182.323 250.214 178.944 C 250.018 177.31 250.242 175.731 251.112 174.319 C 251.197 174.706 251.253 175.122 251.337 175.536 C 252.039 178.806 254.902 181.188 255.153 184.65 C 255.351 187.78 254.817 192.129 251.87 193.984 Z M 238.033 184.761 C 237.921 186.118 237.921 186.922 237.724 188.251 C 237.472 190.106 237.331 191.049 237.528 192.904 C 237.556 193.209 237.584 193.375 237.639 193.679 C 237.303 192.101 236.685 190.301 236.77 188.084 C 236.854 185.536 237.865 183.293 238.454 181.769 C 238.454 181.797 238.145 183.541 238.033 184.761 Z M 235.226 188.749 C 233.374 186.866 232.925 184.151 232.981 181.602 C 232.981 181.105 232.981 180.634 232.925 180.135 C 234.496 178.972 232.644 177.144 231.858 176.091 C 232.531 176.424 235.367 178.03 234.609 179 C 234.749 179.249 234.861 179.497 235.002 179.747 C 235.647 181.132 236.04 182.6 236.208 184.096 C 236.405 185.786 236.208 187.475 235.619 189.082 C 235.479 188.971 235.338 188.86 235.226 188.749 Z M 237.163 194.317 C 235.367 193.679 233.57 191.491 232.644 189.885 C 231.718 188.195 231.129 186.312 230.932 184.401 C 230.82 183.32 230.678 182.24 230.539 181.16 C 231.661 180.385 230.118 178.279 229.753 177.421 C 230.623 177.975 232.953 179.803 231.55 180.828 C 231.746 181.852 231.915 182.905 232.111 183.93 C 232.644 186.422 233.598 188.472 234.861 190.716 C 235.535 191.935 236.321 193.154 237.163 194.317 Z M 230.875 176.729 C 229.416 175.427 227.563 174.651 226.104 173.377 C 223.859 171.41 221.388 169.001 221.445 165.815 C 221.529 164.264 222.652 161.079 221.782 159.833 C 222.764 160.609 223.41 162.104 223.831 163.239 C 224.504 165.261 224.869 167.366 225.627 169.388 C 226.778 172.075 228.938 174.54 230.875 176.729 Z M 258.241 177.836 C 257.4 176.479 256.473 175.177 255.407 173.958 C 255.266 173.792 255.126 173.654 254.957 173.488 C 254.733 173.294 254.621 173.155 254.424 172.934 C 254.424 172.934 254.367 172.574 254.367 172.547 C 253.638 170.165 253.273 167.616 254.564 165.372 C 255.406 164.071 257.933 161.799 257.792 160.304 C 258.269 161.467 258.101 163.073 257.904 164.264 C 257.511 166.37 256.809 168.391 256.472 170.497 C 256.389 171.355 256.361 172.214 256.416 173.1 C 256.586 175.371 258.045 177.282 258.241 177.836 Z"
            fill="white"
            style=""
          />
        </svg>
      </nuxt-link>
      <nuxt-link to="/" style="margin-left: 1rem">
        <v-img max-width="200" src="customers/sfpuc/logo.png" />
      </nuxt-link>
      <v-toolbar-title style="width: 400px" class="ml-4 pl-4">
        <span class="hidden-sm-and-down"
          >{{ mainTitle }} • {{ title | capitalize }}</span
        >
      </v-toolbar-title>
      <v-spacer />
      <client-only>
        <profile-menu />
      </client-only>
    </v-app-bar>
    <nuxt />
    <snackbar />
  </v-app>
</template>

<script>
import Snackbar from "@/components/Snackbar";
import ProfileMenu from "@/components/ProfileMenu";

export default {
  middleware: ["auth"],
  components: { Snackbar, ProfileMenu },
  data({ $config }) {
    return {
      mainTitle: $config.PAGE_TITLE,
    };
  },
  computed: {
    title() {
      if (this.$route.path.includes("/users"))
        return this.$t("user access manager");
      return this.$t("applications");
    },
  },
};
</script>

<style lang="scss">
#daisukeApp {
  .daisuke-main-bar .v-toolbar__content {
    padding: 0 16px 0 0;
  }
  .home-link {
    text-decoration: none;
    height: 100%;
  }
  .bordered-bar {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  .v-input.v-input--is-disabled input,
  .v-select,
  .v-label {
    color: #00000099;
  }
  .v-select__selection--disabled {
    color: #2c2c2c;
  }
  .v-text-field--outlined.v-input--is-disabled fieldset {
    border-color: #0000000d;
  }
  .v-badge__badge .v-icon {
    color: inherit;
    font-size: 12px;
    margin: 0 -2px;
  }
}
</style>
